import { makeStyles } from '@mui/styles';
import styled from 'styled-components';

export const useStyles = makeStyles(() => ({
	rangeDataGrid: {
		'& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
			outline: 'none',
		},
	},
}));

export const TextOverflowWrapper = styled.div`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
